/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SudoTriggerClientUpdateMutationInput = {
    clientMutationId?: string | null | undefined;
    force: boolean;
};
export type SudoTriggerClientUpdateMutationVariables = {
    input: SudoTriggerClientUpdateMutationInput;
};
export type SudoTriggerClientUpdateMutationResponse = {
    readonly sudoTriggerClientUpdate: {
        readonly clientMutationId: string | null;
        readonly sudo: {
            readonly id: string;
            readonly chromeAppUpdateTimes: {
                readonly idleTime: unknown | null;
                readonly forceTime: unknown | null;
            } | null;
        } | null;
    } | null;
};
export type SudoTriggerClientUpdateMutation = {
    readonly response: SudoTriggerClientUpdateMutationResponse;
    readonly variables: SudoTriggerClientUpdateMutationVariables;
};



/*
mutation SudoTriggerClientUpdateMutation(
  $input: SudoTriggerClientUpdateMutationInput!
) {
  sudoTriggerClientUpdate(input: $input) {
    clientMutationId
    sudo {
      id
      chromeAppUpdateTimes {
        idleTime
        forceTime
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SudoTriggerClientUpdateMutationPayload",
            "kind": "LinkedField",
            "name": "sudoTriggerClientUpdate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Sudo",
                    "kind": "LinkedField",
                    "name": "sudo",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChromeAppUpdateTimes",
                            "kind": "LinkedField",
                            "name": "chromeAppUpdateTimes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "idleTime",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forceTime",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SudoTriggerClientUpdateMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SudoTriggerClientUpdateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "358b33f2eb39e0b1e29937f2b8eedd46",
            "id": null,
            "metadata": {},
            "name": "SudoTriggerClientUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation SudoTriggerClientUpdateMutation(\n  $input: SudoTriggerClientUpdateMutationInput!\n) {\n  sudoTriggerClientUpdate(input: $input) {\n    clientMutationId\n    sudo {\n      id\n      chromeAppUpdateTimes {\n        idleTime\n        forceTime\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '5ead9cda81cdc892f9aa2ab64fe24c01';
export default node;
